export * from './buscador/buzon-buscador.component';
export * from './detalle/buzon-detalle.component';
export * from './formulario/buzon-formulario.component';
export * from './lista/buzon-lista.component';
